import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const AboutUs: React.FC = () => (
  <Container maxWidth="md">
    <Box sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>About Us</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        <strong>NeighborhoodPulse_SA</strong> is dedicated to connecting residents with trusted local service providers, fostering a sense of community, and making everyday life easier. Our mission is to empower neighborhoods by providing a reliable platform for discovering, booking, and reviewing essential services.
      </Typography>
      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Our Mission</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        To build stronger, more connected communities by making it simple and safe for residents to find and engage with local service providers.
      </Typography>
      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Our Values</Typography>
      <ul>
        <li><strong>Trust:</strong> We prioritize safety and reliability in every connection.</li>
        <li><strong>Community:</strong> We believe in the power of local relationships.</li>
        <li><strong>Transparency:</strong> We encourage honest reviews and open communication.</li>
        <li><strong>Empowerment:</strong> We support both residents and service providers to thrive.</li>
      </ul>

      <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>About TransferHub</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        TransferHub is a revolutionary initiative within NeighborhoodPulse designed to transform professional mobility across South Africa. This comprehensive platform helps professionals discover transfer opportunities, connect with potential matches, and facilitate meaningful career transitions.
      </Typography>
      
      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>TransferHub Features</Typography>
      <ul>
        <li><strong>Professional Profiles:</strong> Create detailed profiles showcasing your skills, experience, and career aspirations</li>
        <li><strong>Smart Matching System:</strong> Our intelligent algorithm connects professionals based on complementary skills and location preferences</li>
        <li><strong>Job Postings:</strong> Browse and post job opportunities specifically tailored for transfer scenarios</li>
        <li><strong>Transfer Requests:</strong> Create detailed requests outlining your current situation and desired outcomes</li>
        <li><strong>Secure Messaging:</strong> Communicate directly with potential matches through our encrypted messaging system</li>
        <li><strong>Geographic Flexibility:</strong> Explore opportunities across different regions of South Africa</li>
      </ul>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Benefits for Professionals</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        TransferHub provides numerous advantages for career development:
      </Typography>
      <ul>
        <li><strong>Expanded Opportunities:</strong> Access a wider range of career opportunities not advertised through traditional channels</li>
        <li><strong>Targeted Networking:</strong> Connect with professionals who have similar career trajectories and goals</li>
        <li><strong>Skill Matching:</strong> Find opportunities that match your specific skill set and career aspirations</li>
        <li><strong>Privacy & Security:</strong> Robust privacy controls ensure professional confidentiality during career transitions</li>
      </ul>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Success Stories</Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Since its launch, TransferHub has facilitated hundreds of successful professional connections. From software developers finding remote work opportunities to teachers discovering positions in underserved areas, the platform has proven its value across various industries.
      </Typography>

      <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Future Vision</Typography>
      <Typography variant="body1">
        We're continuously improving TransferHub based on user feedback. Upcoming features include advanced filtering options, integration with professional development resources, and enhanced matching algorithms. Our goal is to build stronger professional communities and drive economic growth across South Africa by connecting talented professionals with meaningful opportunities.
      </Typography>
    </Box>
  </Container>
);

export default AboutUs; 